import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { GenericComponent } from "../../components/GenericComponent";
import { InputComponent } from "../../components/InputComponent";
import { Beneficiario } from "../../models/Beneficiario";
import { TerceroService } from "../../service/TerceroService";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Menu } from "primereact/menu";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";

export const Tercero = ({ toast, tipo, id, permss, lista, soloLectura, totalTercero = null, tipoFrmEmpresa }) => {
    const generic = new GenericComponent();
    const omodel = new Beneficiario();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const terceroService = new TerceroService();
    const [esRuc, setEsRuc] = useState(false);
    const [dialogTercero, setDialogTercero] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [terceroSeleccionado, setTerceroSeleccionado] = useState(null);
    const menuRef = useRef(null);
    const tablaTercero = useLazyParams({ modelo: omodel.model });
    const { inDrop, inText } = InputComponent({ registers: tablaTercero.data, omodel, generic, errors, control, permss, id: getValues('id'), soloLectura });

    useEffect(() => {
        loadLazyTercero();
        // eslint-disable-next-line
    }, [tablaTercero.lazyParams, id]);

    const onChangeTipo = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogos.ruc));
    }

    const hideDialog = () => { setDialogTercero(false) }

    const openNew = () => {
        setEsRuc(false);
        if (catalogos == null) {
            terceroService.newTercero({ iniciar: 1, tipoFrmEmpresa }).then(res => {
                setCatalogos(res.data);
                setDialogTercero(true);
                reset(defaultValues);
            });
        }
        else {
            setDialogTercero(true);
            reset(defaultValues);
        }
    }

    const loadLazyTercero = () => {
        tablaTercero.setLoading(true);
        const _params = { ...tablaTercero.lazyParams, idp: id, tipo: tipo };
        terceroService.getLista({ lazyEvent: JSON.stringify(_params) }).then(res => {
            tablaTercero.setTotalRecords(res.data.total);
            tablaTercero.setData(res.data.registros);
            if(totalTercero) totalTercero(res.data.total);
        }).finally(() => tablaTercero.setLoading(false));
    }

    const onSubmit = (data) => {
        data.idp = id;
        data.tipo = tipo;
        data.ruc = catalogos.ruc;

        const request = getValues('id') == null ? terceroService.newTercero(data) : terceroService.editarTercero(data);
        request.then(res => {
            setDialogTercero(false);
            loadLazyTercero();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    }

    const editTercero = () => {
        const iniciar = catalogos == null ? 1 : 0;
        terceroService.getTercero(terceroSeleccionado?.id, iniciar).then(res => {
            let _cats = catalogos;
            if (iniciar === 1) {
                setCatalogos(res.data.catalogo);
                _cats = res.data.catalogo;
            }
            const _tercero = res.data.tercero;

            setEsRuc(JSON.stringify(_tercero.tipo_identificacion) === JSON.stringify(_cats.ruc));
            if (JSON.stringify(_tercero.tipo_identificacion) === JSON.stringify(_cats.ruc)) {
                _tercero.nombres = '';
                _tercero.apellidos = '';
            }
            else {
                _tercero.razon_social = '';
            }
            reset(_tercero);
            setDialogTercero(true);
        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminarTercero()
        });
    }

    const eliminarTercero = () => {
        terceroService.eliminar(terceroSeleccionado?.id, id, tipo).then(res => {
            loadLazyTercero();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Por favor revise los campos del formulario', life: 3000 });
    }

    const itemsMenu = () => {
        if (soloLectura) {
            return [{ label: 'Opciones', items: [{ label: 'Ver detalle', icon: 'pi pi-eye', command: () => editTercero() }] }];
        }

        const items = [];
        if (permss?.actualizar) items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => editTercero() });
        if (permss?.eliminar) items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => confirmDelete() });
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => (
        <Button
            icon="pi pi-caret-down"
            type="button"
            className="p-button-rounded p-button-success mr-2"
            title="Opciones/Acciones"
            aria-controls="popup_menu_tercero"
            aria-haspopup
            onClick={(e) => { setTerceroSeleccionado(rowData); menuRef.current.toggle(e); }}
        />
    );

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '4rem', textAlign: 'center' }} frozen alignFrozen="right" />
    );

    const cabeceraTabla = () => (
        <div className="flex align-items-center justify-content-start gap-3 py-1">
            {permss?.crear && id && !soloLectura && (
                <Button icon="pi pi-plus" className="p-button-success p-button-sm" type="button" onClick={openNew} />
            )}
            <span className="text-sm font-semibold text-600 uppercase tracking-wider">
                Listado de Beneficiarios / Terceros
            </span>
        </div>
    );

    return (
        <>
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu_tercero" />
            <TablaDinamica
                modelo={omodel.model}
                estadoTabla={tablaTercero}
                datos={tablaTercero.data}
                totalRegistros={tablaTercero.totalRecords}
                dataKey="id"
                acciones={ColumnaAcciones}
                header={cabeceraTabla()}
            />

            <Dialog visible={dialogTercero} header={soloLectura ? "Ver Beneficiario/Tercero" : (getValues('id') == null ? "Nuevo Beneficiario/Tercero" : "Editar Beneficiario/Tercero")} modal className="p-fluid modal-ssize" onHide={() => setDialogTercero(false)}>
                <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                    <div className="col-12 mb-3">
                        <div className="flex align-items-center">
                            <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                                <i className="pi pi-user text-primary"></i>
                                BENEFICIARIO / TERCERO
                            </span>
                            <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                        </div>
                    </div>

                    <Card className="mb-3 section-card">
                        <div className="formgrid grid">
                            {inDrop('tipo_identificacion', catalogos?.tipo, { lab: omodel.optionLabel, chn: onChangeTipo, val: null }, 6)}
                            {inText('identificacion', {icon: 'pi pi-id-card'}, 6)}
                        </div>
                        <div className="formgrid grid">
                            {esRuc && inText('razon_social', {icon: 'pi pi-building'}, 12)}
                            {!esRuc && inText('nombres', {icon: 'pi pi-user'}, 6)}
                            {!esRuc && inText('apellidos', {icon: 'pi pi-user'}, 6)}
                            {inDrop('nacionalidad', lista?.nacionalidad, { lab: omodel.optionLabel }, 6)}
                            {inDrop('genero', catalogos?.genero, { lab: omodel.optionLabel }, 6)}
                        </div>
                    </Card>

                    {soloLectura ? (
                        <div className="flex justify-content-end mt-3">
                            <Button label="Cerrar" icon="pi pi-times" type="button" className="p-button-warning" onClick={hideDialog} />
                        </div>
                    ) : (
                        generic.buttonsForms(hideDialog)
                    )}
                </form>
            </Dialog>
        </>
    )
}
